import {
  AUDIO,
  ACCOUNT_SETTINGS,
  BOOKMARK,
  BOOKMARKS,
  UNBOOKMARK,
  LIVE,
  LIVES,
  PROGRAM,
  SEASON,
  VIDEO,
  SERVICE,
  HOME_ALIAS,
  SERVICES,
  PROFILE,
  SEARCH,
  SETTINGS,
  USAGE_TERMS,
  SUBSCRIPTION_TERMS,
  LEGAL_CONDITIONS,
  ACCESSIBILITY_STATEMENT,
  PRIVACY_POLICY,
  FOLDERS,
  FOLDER,
  INFORMATION,
  CLOSE,
  OPTOUT,
  LOCK,
  LOGOUT,
  FRONTSPACE,
  HELP,
  FEEDBACK,
  PROFILES_GATE,
  PLAY,
  RADIO,
} from '@bedrock-rdk/constants';

export default {
  AUDIO,
  ACCOUNT_SETTINGS,
  BOOKMARK,
  BOOKMARKS,
  UNBOOKMARK,
  LIVE,
  LIVES,
  PROGRAM,
  SEASON,
  VIDEO,
  SERVICE,
  HOME_ALIAS,
  SERVICES,
  PROFILE,
  SEARCH,
  SETTINGS,
  USAGE_TERMS,
  SUBSCRIPTION_TERMS,
  LEGAL_CONDITIONS,
  ACCESSIBILITY_STATEMENT,
  PRIVACY_POLICY,
  FOLDERS,
  FOLDER,
  INFORMATION,
  CLOSE,
  OPTOUT,
  LOCK,
  LOGOUT,
  FRONTSPACE,
  HELP,
  FEEDBACK,
  PROFILES_GATE,
  PLAY,
  RADIO,
};
